import Vue from 'vue';
import { getPassportUrl } from './../../../../utils/other';
export default Vue.extend({
    name: 'regAfterKyc',
    props: {
        page: {
            type: String,
            required: true
        }
    },
    computed: {
        faq() {
            return getPassportUrl('/kyc-faq', { withAcceptor: true });
        }
    },
    methods: {
        proceedKyc() {
            const url = getPassportUrl('/id/?verification-show=true&auto-proceed-kyc=true', { withAcceptor: true });
            window.location.href = String(url);
        }
    }
});
